<template>
  <div>
    <a-modal
      v-if="visible"
      title="工单批次界面"
      :width="1000"
      :visible="visible"
      :maskClosable="false"
      :footer="null"
      @cancel="close"
    >
      <!-- <certificate-print style="width: 70mm" ref="certificateRef" id="certificateId" /> -->
      <div class="table-page-operator-wrapper table-page-operator-wrapper-top">
        <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
          <a-form-item label="执行标准">
            <global-select
              selectType="selectSearch"
              :value.sync="executiveStandard"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/likeList"
              :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
              :setParams="{ lookupType: 'EXECUTION_STANDARDS' }"
              searchParam="lookupValue"
            />
          </a-form-item>
          <a-form-item label="合格证抬头">
            <global-select
              selectType="select"
              :allowClear="false"
              :value.sync="titleVal"
              :dropdown-match-select-width="false"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
              :setParams="{ lookupType: 'MES_CERTIFICATE_TITLE' }"
              searchParam="lookupValue"
            />
          </a-form-item>
        </a-form>
        <a-button type="primary" :disabled="selectedRowKeys.length === 0" :loading="ctfcLoading" @click="printCtfc(selectedRowKeys)">打印合格证</a-button>
        <a-button ref="certificateBtn" v-show="false" v-print="'#certificateId'">打印合格证</a-button>
        <a-button type="primary" :disabled="selectedRowKeys.length === 0" :loading="lbLoading" @click="printLb(selectedRowKeys)">打印标签</a-button>
        <a-button ref="labelBtn" v-show="false" v-print="'#labelId'">打印标签</a-button>
        <a-button ref="hwLabelBtn" v-show="false" v-print="'#hwLabelId'">五金箱打印标签</a-button>
      </div>
      <a-table
        ref="modalTable"
        :columns="columns"
        :data-source="tableList"
        :pagination="false"
        :loading="tableLoading"
        row-key="lotNumber"
        :row-selection="rowSelection"
        :scroll="{ x: 700, y: 260 }"
      >
        <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
          <div :key="item.dataIndex">
            <span v-if="item.dataIndex === 'operation'">
              <a-button type="primary" size="small" @click="nextModal(record)">标签码</a-button>
            </span>
            <span v-else>{{ text }}</span>
          </div>
        </template>
      </a-table>
    </a-modal>
    <a-modal
      title="标签界面"
      :width="800"
      :visible="visibleNew"
      :maskClosable="false"
      :footer="null"
      :zIndex="2000"
      @cancel="closeNew"
    >
      <a-table
        :columns="columnsNew"
        :data-source="tableListNew"
        :pagination="false"
        :loading="tableLoadingNew"
        row-key="id"
        :scroll="{ x: 700, y: 290 }"
      >
        <template v-for="item in columnsNew" :slot="item.dataIndex" slot-scope="text">
          <div :key="item.dataIndex">
            <span>{{ text }}</span>
          </div>
        </template>
      </a-table>
    </a-modal>
    <div class="display-none">
      <certificate-print ref="certificateRef" id="certificateId" />
      <label-print ref="labelRef" :isZh="isZh" id="labelId" />
      <hw-label-print ref="hwLabelRef" id="hwLabelId" :showCode="showCode" />
    </div>
  </div>
</template>

<script>
import { apiMesDiscreteJobsPrintCertificateConformityPage, apiMesDiscreteJobsSerialNumberPopup, apiMesDiscreteJobsPrintCertificateConformity, apiMesDiscreteJobsPrintLabel } from '@/api/mes/workOrderManage/workOrderSent'
import CertificatePrint from './certificate-print2'
import LabelPrint from './label-print'
import HwLabelPrint from './hw-label-print.vue'
export default {
  props: {},
  components: {
    CertificatePrint,
    HwLabelPrint,
    LabelPrint
  },
  data () {
    return {
      isWj: false, // 判断是否为五金单WJ_STANDARD
      isZh: false, // 判断是否为专货5
      visible: false,
      visibleNew: false,
      showCode: true, // 是否展示条形码, 默认展示
      columns: [
        {
          title: '批次号',
          width: 180,
          align: 'center',
          dataIndex: 'lotNumber'
        },
        {
          title: '品质状态',
          width: 150,
          align: 'center',
          dataIndex: 'qualityStatusName'
        },
        {
          title: '目的仓',
          width: 120,
          align: 'center',
          dataIndex: 'destinationName'
        },
        {
          title: '备注',
          width: 150,
          align: 'center',
          dataIndex: 'remarks'
        },
        {
          title: '合格证打印次数',
          width: 150,
          align: 'center',
          dataIndex: 'certificatePrintingTimes'
        },
        {
          title: '标签打印次数',
          width: 150,
          align: 'center',
          dataIndex: 'labelPrintingTimes'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      columnsNew: [
        {
          title: '标签码',
          width: 150,
          align: 'center',
          dataIndex: 'serialNumber'
        },
        {
          title: '包件序号',
          width: 150,
          align: 'center',
          dataIndex: 'packageNumber'
        },
        {
          title: '包装明细',
          width: 150,
          align: 'center',
          dataIndex: 'packageList'
        },
        {
          title: '托盘',
          width: 150,
          align: 'center',
          dataIndex: 'palletNo'
        },
        {
          title: '报工标识',
          width: 150,
          align: 'center',
          dataIndex: 'packagingCompletionFlag'
        },
        {
          title: '入库标识',
          width: 150,
          align: 'center',
          dataIndex: 'storageFlag'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      tableList: [],
      tableListNew: [],
      tableLoading: false,
      tableLoadingNew: false,
      wipEntityId: "",
      ctfcLoading: false,
      lbLoading: false,
      titleVal: '林氏家居',
      executiveStandard: ''
    }
  },
  created () {},
  methods: {
    // 打印合格证
    printCtfc (val) {
      this.ctfcLoading = true
      if (!this.executiveStandard) {
        this.$message.warning("请先选择执行标准！")
        this.ctfcLoading = false
        return
      }
      apiMesDiscreteJobsPrintCertificateConformity(val).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.$refs.certificateRef.show(res.data, this.executiveStandard, this.titleVal)
          this.$refs.certificateBtn.$el.dispatchEvent(new MouseEvent("click"))
        } else {
          this.$message.warning("无合格证打印数据！")
        }
        this.ctfcLoading = false
      }).catch(e => {
        this.ctfcLoading = false
      })
    },
    // 打印标签
    printLb (val) {
      this.lbLoading = true
      apiMesDiscreteJobsPrintLabel(val).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          if(this.isWj) {
            // 五金箱
            this.$refs.hwLabelRef.show(res.data)
            setTimeout(() => {
              this.$refs.hwLabelBtn.$el.dispatchEvent(new MouseEvent("click"))
            }, 200)
          } else {
            // 组装
            this.$refs.labelRef.show(res.data)
            setTimeout(() => {
              this.$refs.labelBtn.$el.dispatchEvent(new MouseEvent("click"))
            }, 200)
          }
        } else {
          this.$message.warning("无标签打印数据！")
        }
        this.lbLoading = false
      }).catch(e => {
        this.lbLoading = false
      })
    },
    // 工单批次界面
    show (val, row) {
      this.visible = true
      this.titleVal = '林氏家居' // 默认林氏家居
      this.selectedRowKeys = []
      this.selectedRows = []
      this.columns = JSON.parse(JSON.stringify(this.columns))
      this.wipEntityId = val
      this.getList()
      this.showCode = true
      // 判断计划单号是否有PSLJ开头，有则不展示条形码
      if(row?.orderNo?.startsWith("PSLJ")) { this.showCode = false }
      this.isWj = row?.jobType === "WJ_STANDARD" // 判断是否为五金单WJ_STANDARD
      this.isZh = row?.orderType === '5' // 专货
    },
    // 关闭模态框
    close () {
      this.visible = false
    },
    closeNew () {
      this.visibleNew = false
    },
    // 标签界面
    nextModal (record) {
      this.visibleNew = true
      this.getListNew(record.id)
    },
    // 工单批次界面
    getList () {
      this.tableLoading = true
      apiMesDiscreteJobsPrintCertificateConformityPage(this.wipEntityId).then(response => {
        this.tableList = response.data || []
        this.tableLoading = false
      })
    },
    // 标签界面
    getListNew (id) {
      this.tableLoadingNew = true
      apiMesDiscreteJobsSerialNumberPopup(id).then(response => {
        this.tableListNew = response.data || []
        this.tableLoadingNew = false
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.display-none {
  display: none;
}
.table-page-operator-wrapper-top {
  display: flex;
  align-items: center;
  /deep/.ant-select {
    width: 150px;
  }
}
</style>
